let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6phqU")).then(() => parcelRequire('97ib0'));